export var ModalSize;
(function (ModalSize) {
    ModalSize[ModalSize["X_SMALL"] = 10] = "X_SMALL";
    ModalSize[ModalSize["SMALL"] = 20] = "SMALL";
    ModalSize[ModalSize["MEDIUM"] = 30] = "MEDIUM";
    ModalSize[ModalSize["MEDIUM_LARGE"] = 35] = "MEDIUM_LARGE";
    ModalSize[ModalSize["LARGE"] = 40] = "LARGE";
})(ModalSize || (ModalSize = {}));
//# sourceMappingURL=modal-size.js.map